<template>
  <div id="projectApplicationCus">
		<el-dialog
			title="Customer"
			width="1000px"
			top="5vh"
			:visible.sync="customerDialog"
			:close-on-click-modal="false"
		>
			<el-form :model="searchForm" ref="searchForm" label-width="130px">
				<el-row>
					<el-col :span="8">
						<el-form-item label="GTS Number:" prop="companyId">
							<el-input clearable v-model="searchForm.companyId" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="Customer Name:" prop="companyFullName">
							<el-input clearable v-model="searchForm.companyFullName" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="Customer Type:" prop="clientTypeName">
							<el-select clearable v-model="searchForm.clientTypeName" placeholder="Please select">
								<el-option
									v-for="item in typeData"
									:key="item"
									:label="item"
									:value="item"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="Industry:" prop="industryName">
							<el-input clearable v-model="searchForm.industryName" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="Office Name:" prop="officeName">
							<el-input clearable v-model="searchForm.officeName" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="Customer Level:" prop="serviceLevelName">
							<el-select clearable v-model="searchForm.serviceLevelName" placeholder="Please select">
								<el-option
									v-for="item in levelData"
									:key="item"
									:label="item"
									:value="item"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="24" style="padding: 10px 0 0 20px; text-align: right;">
						<el-button type="primary" size="small" @click="handleSearch()">Search</el-button>
						<el-button size="small" @click="handleReset()">Reset</el-button>
					</el-col>
				</el-row>
			</el-form>
			<el-table :data="tableData" size="small" border v-loading="tableLoading" style="width: 100%; margin-top: 20px;" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
        <el-table-column prop="companyId" label="GTS Number"></el-table-column>
        <el-table-column prop="companyFullName" label="Customer Name" align="center">
					<template slot-scope="scope">
						<a style="color:blue;" @dblclick="handleDoubleClick(scope.row)">{{ scope.row.companyFullName }}</a>
					</template>
				</el-table-column>
        <el-table-column prop="clientTypeName" label="Customer Type" align="center"></el-table-column>
        <el-table-column prop="industryName" label="Industry" align="center"></el-table-column>
        <el-table-column prop="officeName" label="Office Name" align="center"></el-table-column>
        <el-table-column prop="serviceLevelName" label="Customer Level" align="center"></el-table-column>
      </el-table>
			<div class="pageDiv" v-if="totalCount && totalCount > 0">
				<el-pagination
					small
					layout="total, prev, pager, next, sizes, jumper"
					:page-sizes="[10, 20, 50, 100]"
					:current-page="currentPage"
					:page-size="pageSize"
					:total="totalCount"
					@size-change="changePageSize"
					@current-change="changePage"

				>
				</el-pagination>
			</div>
		</el-dialog>
  </div>
</template>
<script>
  import {_debounce} from '@/utils/selectAPI'
  import * as validate from '@/utils/validate'
	import axios from 'axios'
  export default {
    name: 'projectApplicationCustomer',
    created () {
			this.getSelect();
			this.handleSearch();
		},
		watch: {
		},
    data () {
      return {
				customerDialog: false,
				typeData: [],
				levelData: [],
				searchForm: {},
				tableData: [],
				tableLoading: false,
				currentPage: 1,
				pageSize: 10,
				totalCount: 1,
				exportLoading: false,
      }
    },
    methods: {
			getSelect() {
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
				}
				this.tableLoading = true;
				let url =`${this.$store.state.islhurl}sipCmsCustomer/selectClientTypeName`
				this._get(url).then(
					res => {
						if(res.code === 200) {
						this.typeData = res.data;
						} else {
							this.typeData = [];
						}
					}
				)
				let url2 =`${this.$store.state.islhurl}sipCmsCustomer/selectServiceLevelName`
				this._get(url2).then(
					res => {
						if(res.code === 200) {
						this.levelData = res.data;
						} else {
							this.levelData = [];
						}
					}
				)
			},
			handleSearch() {
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
					...this.searchForm,
				}
				this.tableLoading = true;
				let url =`${this.$store.state.islhurl}sipCmsCustomer/getListByPage/${this.pageSize}/${this.currentPage}`
				this._post(url,params).then(
					res => {
						this.tableLoading = false;
						if(res.code === 200) {
						this.tableData = res.data;
						this.totalCount = res.totalNums;
						} else {
							this.tableData = [];
							this.$message.error(res.message || 'Failed!' );
						}
					}
				)
			},
			changePageSize(size) {
				this.pageSize = size;
				this.handleSearch();
			},
			changePage(current) {
				this.currentPage = current;
				this.handleSearch();
			},
			handleReset() {
				this.searchForm = {};
			},
			handleDoubleClick(record) {
				this.$emit('setCustomerName', record.companyFullName)
				this.customerDialog = false;
			}
		},
  }
</script>
<style lang="less" scoped>
#projectApplicationCus {
	.el-form {
		padding: 20px 0 20px 0;
		.el-form-item {
			margin-bottom: 10px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 0px;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
		}
	}
	.el-table {
		/deep/th.el-table__cell>.cell {
			word-break: break-word;
		}
	}
	/deep/.el-dialog__body {
		border-top: 1px solid #e8eaec;
		border-bottom: 1px solid #e8eaec;
		.el-form {
			padding: 0;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/major/projectApplication/customerList.vue